module.exports = __webpack_public_path__ + "static/media/8OLA11.d1bf9930.jpg";